module.exports = __webpack_public_path__ + "img/close.3f192008.png";